import { useContext, useEffect, useState, useMemo } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, Spinner, Alert} from 'reactstrap';

import { AuthContext } from '../context/AuthContext';

const MfaModal = () => {
    const auth = useContext(AuthContext);

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Lock input when challenge is invalidated
    const [isLocked, setIsLocked] = useState(false);
    useEffect(() => {
        if (error.includes("OTP is no longer valid")) {
            setIsLocked(true);
        }
        else {
            setIsLocked(false);
        }
    }, [error])

    const onSubmit = async (e) => {
        e.preventDefault()
        const otp = e.target.elements[0].value

        setIsLoading(true);
        try {
            await auth.verifyMfa({ otp })
            setError("");
        }
        catch (e) {
            setError(e.toString());
        }
        setIsLoading(false);
    }

    const onClose = () => {
        // NOTE: No longer correct to call this, because the token is expected to be resused.
        // auth.cancelMfaVerification();
        auth.toggleMfaVerification();
        setError("");
    }

    const alert = useMemo(() => {
        if (error) {
            if (error === "Error: OTP verification failed") {
                return "Verificación multifactorial ha fallado. Verifique que haya ingresado el código de acceso correctamente."
            }
            else if (error === "Error: OTP has expired") {
                return "El código de acceso ha expirado. Ingresé sus credenciales nuevamente."
            }
            else if (error.includes("OTP is no longer valid")) {
                return "Verificación multifactorial ha fallado demasiadas veces, por lo cual el código de acceso ha expirado. Ingresé sus credenciales nuevamente."
            }
            return error
        }

        let mfaTypeString = "";
        const out = [];
        switch (auth.mfaType) {
            case "EMAIL_OTP":
                out.push(<>
                    <strong>Verifique su correo electrónico para obtener el código de acceso.</strong><br/>
                    El mensaje puede tardar unos minutos en llegar.<br/><br/>
                    Si no lo recibe, intente nuevamente o comuníquese con la <strong>División de Transporte de la ASG</strong> para asistencia.
                </>);
                mfaTypeString = "correo electrónico";
                break;
        }

        if (auth.hasMfaReminder) {
            out.push(<br/>); out.push(<br/>);
            out.push(<>
                Previamente se envió un código de acceso a su {mfaTypeString}.

                Asegurese de que haya recibido el código.
                {/* Si nunca lo recibió, <button tabIndex="0" styling="link" onClick={(e) => e.preventDefault()}>puede reenviarlo.</button> */}
            </>);
        }

        return out
    }, [auth, error])
 
    return (
        <Modal isOpen={auth.hasMfaVerification} size='lg'>
            <ModalHeader>Verificación multifactorial </ModalHeader>
            <ModalBody>
                <Form onSubmit={onSubmit}>
                    {alert ? <Alert color={error ? "danger" : "primary"} show="true" >{alert}</Alert> : null}
                    <Label for="otp">Entre su código de acceso </Label>
                    <FormGroup>
                        <Input type="text" name="otp" id="otp" placeholder="xxxxxxxx" required/>
                    </FormGroup>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '1em'}}>
                        <Button className="btn btn-primary2" color="primary" type="submit" disabled={isLoading || isLocked}>
                            {isLoading ? [<Spinner size="sm"/>, ' '] : null}
                            Someter
                        </Button>

                        <Button className="btn btn-primary" color="primary" onClick={onClose}>
                            Cerrar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
}

export default MfaModal;